import React from 'react';
import { Divider, Dropdown, Input, MessageBarBody, MessageBarTitle, Option, Textarea } from '@fluentui/react-components';
import { useEffect, useState } from 'react';
import { DateTimeInput } from '../../../../commons/component/Inputs/DateTimeInput/DateTimeInput';
import { Contract } from '../../../../models/Entities/Contracts/Contract';

// functions
import * as Functions from './ProtocolContractFormFunctions';

// guide components
import { GuideDrawer, GuideDrawerForm } from '../../../../theme/components/GuideDrawer';
import { GuideField } from '../../../../theme/components/GuideField';
import { GuideMessageBar } from '../../../../theme/components/GuideMessageBar';

////i18Next
import { useTranslation } from 'react-i18next';

// styles (shared with the concept / stages sub-forms)
import './ProtocolContractFormComponent.css';
import { NewContractStage } from '../../../../models/Entities/Contracts/NewContractStage';
import { CurrencySelectorComponent } from '../../../../commons/component/Inputs/CurrencySelector/CurrencySelectorComponent';
import { ContractConcept } from '../../../../models/Entities/Contracts/ContractConcept';
import { SponsorSelectorComponent } from '../../../../commons/component/Inputs/SponsorSelector/SponsorSelectorComponet';
import { ContractStage } from '../../../../models/Entities/Contracts/ContractStage';
import PractitionerSelectorComponent from '../../../../commons/component/Inputs/PractitionerSelector/PractitionerSelectorComponent';
import { NewContractConcept } from '../../../../models/Entities/Contracts/NewContractConcept';
import { NewContract } from '../../../../models/Entities/Contracts/NewContract';
import { connect } from 'react-redux';
import { Practitioner } from '../../../../models/Entities/Practitioners/Practitioner';

interface FormValidation {
  success: boolean;
  errors: string[];
}

export const ProtocolContractFormComponent = (props: Functions.Props) => {
  const [submittedForm, setSubmittedForm] = useState<boolean>(false);
  const [FormValidationStatus, setFormValidationStatus] = useState<
    FormValidation | undefined
  >();

  const [contractNumber, setContractNumber] = useState<string>('');
  const [contractDescription, setContractDescription] = useState<string>('');
  const [contractStatus, setContractStatus] = useState<number>(0);
  const [contractStartDate, setContractStartDate] = useState<Date>();
  const [contractEndDate, setContractEndDate] = useState<Date>();
  const [contractCurrency, setContractCurrency] = useState<string>('');
  const [paymentScheduleType, setPaymentScheduleType] = useState<number>(0);
  const [paymentScheduleFrequency, setPaymentScheduleFrecuency] =
    useState<number>(0);
  const [firstSettlement, setFirstSettlement] = useState<Date>(new Date());
  const [ParentContractId, setParentContractId] = useState<number | undefined>();
  const [isLocked, setIsLocked] = useState<boolean>(false);
  const [useContractStages, setUseContractStages] = useState<boolean>(false);

  const [concepts, setConcepts] = useState<ContractConcept[]>([]);
  const [Stages, setStages] = useState<NewContractStage[] | ContractStage[]>(
    []
  );
  const [Participation, setParticipation] = useState<number>(0);

  //useTranslation()
  const [t] = useTranslation();

  // effects

  useEffect(() => {
    if (props.Contract) {
      setContractNumber(props.Contract.contractNumber);
      setContractDescription(props.Contract.contractDescription);
      setContractStatus(props.Contract.contractStatus);
      setContractStartDate(props.Contract.contractStartDate);
      setContractEndDate(props.Contract.contractEndDate);
      setContractCurrency(props.Contract.contractCurrency);
      setContractStatus(props.Contract.contractStatus);
      setPaymentScheduleType(props.Contract.paymentSheduleType);
      setParentContractId(props.Contract.parentContractId);
      setIsLocked(props.Contract.isLocked);
    }
  }, [props.Contract]);


  useEffect(() => {
    if (props.isAddedSuccessfully || props.isUpdatedSuccessfully) {
      ResetForm();
      props.dismissPanel();
    }
  }, [submittedForm, props.isAddedSuccessfully, props.isUpdatedSuccessfully]);

  // reset form
  const ResetForm = () => {
    setSubmittedForm(false);
    setContractNumber('');
    setContractDescription('');
    setContractStatus(0);
    setContractStartDate(undefined);
    setContractEndDate(undefined);
    setContractCurrency('');
    setPaymentScheduleType(0);
    setPaymentScheduleFrecuency(0);
    setFirstSettlement(new Date());
    setUseContractStages(false);
    setParentContractId(undefined);
    setIsLocked(false);
    setConcepts([]);
    setStages([]);
    setParticipation(0);
  };

  // form events
  const handleContractStartDateChange = (seletedDate: Date | undefined) => {
    setContractStartDate(seletedDate);
  };
  const handleContractEndDateChange = (seletedDate: Date | undefined) => {
    setContractEndDate(seletedDate);
  };

  const ValidateForm = (): boolean => {
    let validationResult: boolean = true;

    let FormValidation: FormValidation = { success: true, errors: [] };
    setFormValidationStatus(FormValidation);

    FormValidation.success = validationResult;
    setFormValidationStatus(FormValidation);
    return validationResult;
  };

  //events

  const HandleCancelForm = () => {
    ResetForm();
    props.dismissPanel();
  };
  const HandleSubmitForm = () => {
    setSubmittedForm(true);
    if (ValidateForm()) {
      // submit form
      if (!props.Contract) {
        const newContract: NewContract = {
          contractNumber: contractNumber,
          contractDescription: contractDescription,
          contractStatus: contractStatus,
          contractStartDate: contractStartDate,
          contractEndDate: contractEndDate,
          contractCurrency: contractCurrency,
          concepts: concepts,
          feeDivision: Participation,
          useContractStages: useContractStages,
          paymentScheduleType: paymentScheduleType,
          paymentScheduleFrequency: paymentScheduleFrequency,
          commissionAgents: [],
          stages: [],
        };
        props.AddContract(newContract)
      } else {
        const Contract: Contract = {
          id: props.Contract.id,
          // set through the verify action in the contract header, not editable here
          contractVerified: props.Contract.contractVerified ?? false,
          contractNumber: contractNumber,
          contractDescription: contractDescription,
          contractStatus: contractStatus,
          contractStartDate: contractStartDate,
          contractEndDate: contractEndDate,
          contractCurrency: contractCurrency,
          concepts: concepts,
          feeDivision: Participation,
          useContractStages: useContractStages,
          paymentSheduleType: paymentScheduleType,
          paymentScheduleFrequency: paymentScheduleFrequency,
          parentContractId: ParentContractId,
          isLocked: props.Contract.isLocked,
          commissionAgents: [],
          stages: [],
          cycles: [],
          branches: [],
          sponsors: [],
          practitioners: [],
          protocol: [],
          addendums: [],
          access: [],
          commissionConcepts: [],
          isSaving: false,
          isSavedSuccessfully: undefined,
          failOnSaving: false,
          isUpdating: false,
          isUpdatedSuccessfully: undefined,
          failOnUpdating: false,
          isRedreshing: false,
          isRefreshedSuccessfully: undefined,
          failOnRefreshing: false,
          isCloning: false,
          isClonedSuccessfully: undefined,
          failOnCloning: false,
          error: undefined,
          isGettingContractAddendums: false,
          isGettingContractAddendumsSuccess: undefined,
          FailGettingContractAddendums: false,
          isDeleting: false,
          isDeletedSuccessfully: undefined,
          failOnDeleting: false,
          userCanView: props.Contract.userCanView ?? false,
          userCanModify: props.Contract.userCanModify ?? false,
          userPermissions: props.Contract.userPermissions ?? []
        };
        props.UpdateContract(Contract);
      }
    }
  };

  const selectedStatusOption = Functions.ContractStatusOptions.find(
    (option) => option.key === contractStatus.toString()
  );
  const selectedScheduleOption = paymentScheduleType
    ? Functions.ContractPaymentScheduleTypeOptions.find(
        (option) => option.key === paymentScheduleType.toString()
      )
    : undefined;

  // form fields
  const FormFields = (
    <>
      {props.mode === 'sponsor' && props.RefererId === undefined && (
        <GuideField label={t('protocolContractForm.props.sponsor')}>
          <SponsorSelectorComponent selectionLimit={1} />
        </GuideField>
      )}
      {props.mode === 'practitioner' && props.RefererId === undefined && (
        <GuideField label={t('protocolContractForm.props.practitioner')}>
          <PractitionerSelectorComponent MultiselectEnable={false} SelectedPractitioners={undefined}  onChangeSelection={(selectedPractitioners: Practitioner[] | undefined) => undefined} />
        </GuideField>
      )}
      <GuideField
        label={t('protocolContractForm.props.contractNumber')}
        required
        error={
          submittedForm === true && (contractNumber === undefined || contractNumber.length === 0)
            ? t('protocolContractForm.props.requiredField')
            : undefined
        }
      >
        <Input
          name="txt_contract_number"
          autoComplete="off"
          value={contractNumber || ''}
          onChange={(_, data) => setContractNumber(data.value || '')}
        />
      </GuideField>
      <GuideField label={t('protocolContractForm.props.comments')}>
        <Textarea
          name="txt_contract_description"
          autoComplete="off"
          rows={3}
          resize="vertical"
          value={contractDescription || ''}
          onChange={(_, data) => setContractDescription(data.value || '')}
        />
      </GuideField>
      <DateTimeInput
        label={t('protocolContractForm.props.effectiveDate')}
        placeHolder={undefined}
        selectedDate={contractStartDate ? new Date(contractStartDate) : undefined}
        isRequired={false}
        isSubmitted={submittedForm}
        errorMessage={
          undefined
        }
        onSelectDate={handleContractStartDateChange}
      />
      <DateTimeInput
        label={t('protocolContractForm.props.expirationDate')}
        placeHolder={undefined}
        selectedDate={contractEndDate ? new Date(contractEndDate) : undefined}
        isRequired={false}
        isSubmitted={submittedForm}
        errorMessage={
          undefined
        }
        onSelectDate={handleContractEndDateChange}
      />
      <GuideField label={t('protocolContractForm.props.contractState')}>
        <Dropdown
          placeholder={t('protocolContractForm.props.selectState')}
          value={selectedStatusOption?.text ?? ''}
          selectedOptions={selectedStatusOption ? [String(selectedStatusOption.key)] : []}
          onOptionSelect={(_, data) => setContractStatus(Number(data.optionValue) || 0)}
        >
          {Functions.ContractStatusOptions.map((option) => (
            <Option key={option.key} value={String(option.key)} text={option.text}>
              {option.text}
            </Option>
          ))}
        </Dropdown>
      </GuideField>
      <CurrencySelectorComponent
        errorMessage={undefined}
        defaultSelected={contractCurrency}
        onCurrencyChange={(currency: string) => setContractCurrency(currency)}
        label={t('settlementDetailForm.formData.currency')}
        isRequired={true}
      />
      <Divider />
      <GuideField label={t('protocolContractForm.props.settlementPeriod')} required>
        <Dropdown
          value={selectedScheduleOption?.text ?? ''}
          selectedOptions={selectedScheduleOption ? [String(selectedScheduleOption.key)] : []}
          onOptionSelect={(_, data) => setPaymentScheduleType(Number(data.optionValue) || 0)}
        >
          {Functions.ContractPaymentScheduleTypeOptions.map((option) => (
            <Option key={option.key} value={String(option.key)} text={option.text}>
              {option.text}
            </Option>
          ))}
        </Dropdown>
      </GuideField>
    </>
  );

  return (
    <GuideDrawer
      open={props.isOpen}
      onDismiss={props.dismissPanel}
      size="medium"
      eyebrow={props.Contract?.contractNumber}
      title={t('protocolContractForm.panel.contractInformation')}
      testId="protocol-contract-drawer"
      secondaryAction={{ label: t('protocolContractForm.footer.cancelButton'), onClick: HandleCancelForm }}
      primaryAction={{
        label: t('protocolContractForm.footer.saveButton'),
        onClick: HandleSubmitForm,
        loading: props.isAdding || props.isUpdating,
      }}
    >
      {submittedForm && !FormValidationStatus?.success && (
        <GuideMessageBar intent="error">
          <MessageBarBody>
            <MessageBarTitle>{t('protocolContractForm.panel.reviewInformation')}</MessageBarTitle>
            <ul>
              {FormValidationStatus?.errors.map((error: string, index: number) => (
                <li key={index}>{error}</li>
              ))}
            </ul>
          </MessageBarBody>
        </GuideMessageBar>
      )}
      <GuideDrawerForm onSubmit={HandleSubmitForm} testId="protocol-contract-form">
        {FormFields}
      </GuideDrawerForm>
    </GuideDrawer>
  );
};

export default connect(
  Functions.mapStateToProps,
  Functions.mapDispatchToProps
)(ProtocolContractFormComponent as any)
